// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Aura Operations API
 * API to manage aura-operations
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OperationscatalogFieldType } from './OperationscatalogFieldType';
import {
  OperationscatalogFieldTypeFromJSON,
  OperationscatalogFieldTypeFromJSONTyped,
  OperationscatalogFieldTypeToJSON,
  OperationscatalogFieldTypeToJSONTyped,
} from './OperationscatalogFieldType';
import type { OperationscatalogFieldConstraints } from './OperationscatalogFieldConstraints';
import {
  OperationscatalogFieldConstraintsFromJSON,
  OperationscatalogFieldConstraintsFromJSONTyped,
  OperationscatalogFieldConstraintsToJSON,
  OperationscatalogFieldConstraintsToJSONTyped,
} from './OperationscatalogFieldConstraints';

/**
 *
 * @export
 * @interface OperationscatalogField
 */
export interface OperationscatalogField {
  /**
   *
   * @type {OperationscatalogFieldConstraints}
   * @memberof OperationscatalogField
   */
  constraints?: OperationscatalogFieldConstraints;
  /**
   *
   * @type {string}
   * @memberof OperationscatalogField
   */
  help?: string;
  /**
   *
   * @type {string}
   * @memberof OperationscatalogField
   */
  label?: string;
  /**
   *
   * @type {string}
   * @memberof OperationscatalogField
   */
  name?: string;
  /**
   *
   * @type {boolean}
   * @memberof OperationscatalogField
   */
  required?: boolean;
  /**
   *
   * @type {OperationscatalogFieldType}
   * @memberof OperationscatalogField
   */
  type?: OperationscatalogFieldType;
  /**
   * Values is an optional inline list for choice fields owned by the workflow.
   * @type {Array<string>}
   * @memberof OperationscatalogField
   */
  values?: Array<string>;
}

/**
 * Check if a given object implements the OperationscatalogField interface.
 */
export function instanceOfOperationscatalogField(
  value: object,
): value is OperationscatalogField {
  return true;
}

export function OperationscatalogFieldFromJSON(
  json: any,
): OperationscatalogField {
  return OperationscatalogFieldFromJSONTyped(json, false);
}

export function OperationscatalogFieldFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OperationscatalogField {
  if (json == null) {
    return json;
  }
  return {
    constraints:
      json['constraints'] == null
        ? undefined
        : OperationscatalogFieldConstraintsFromJSON(json['constraints']),
    help: json['help'] == null ? undefined : json['help'],
    label: json['label'] == null ? undefined : json['label'],
    name: json['name'] == null ? undefined : json['name'],
    required: json['required'] == null ? undefined : json['required'],
    type:
      json['type'] == null
        ? undefined
        : OperationscatalogFieldTypeFromJSON(json['type']),
    values: json['values'] == null ? undefined : json['values'],
  };
}

export function OperationscatalogFieldToJSON(
  json: any,
): OperationscatalogField {
  return OperationscatalogFieldToJSONTyped(json, false);
}

export function OperationscatalogFieldToJSONTyped(
  value?: OperationscatalogField | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    constraints: OperationscatalogFieldConstraintsToJSON(value['constraints']),
    help: value['help'],
    label: value['label'],
    name: value['name'],
    required: value['required'],
    type: OperationscatalogFieldTypeToJSON(value['type']),
    values: value['values'],
  };
}
